import { render, staticRenderFns } from "./PropertyRentalHistoryTab.vue?vue&type=template&id=7d7531c6"
import script from "./PropertyRentalHistoryTab.vue?vue&type=script&lang=js"
export * from "./PropertyRentalHistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports